var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"four-side-css-props text-center"},[_c('div'),_c('div',[_c('div',{staticClass:"btnGroup"},_vm._l((_vm.groups),function(group,index){return _c('btn',{key:index,attrs:{"icon":group.icon,"s":"xs","active":_vm.currentGroup === index},on:{"press":function($event){_vm.currentGroup = index}}})})),_c('div',{staticStyle:{"border":"1px solid lightgrey","text-align":"center","display":"inline-block"}},[_c('table',[_c('tbody',[_c('tr',[_c('td'),_c('td',[_c('drag-input',{attrs:{"value":_vm.styleJSON.paddingTop.value,"icon":"caret-up"},on:{"input":function (value){
                            		_vm.setStyle({paddingTop:{value: value, unit:'px'}});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({paddingBottom:{value: value, unit:'px'}});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				paddingLeft:{value: value, unit:'px'},
                            				paddingBottom:{value: value, unit:'px'},
                            				paddingRight:{value: value, unit:'px'}
                            			});
                            		}
                            	}}})],1),_c('td')]),_c('tr',[_c('td',[_c('drag-input',{attrs:{"value":_vm.styleJSON.paddingLeft.value,"icon":"arrows-h"},on:{"input":function (value){
                            		_vm.setStyle({paddingLeft:{value: value, unit:'px'}});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({paddingRight:{value: value, unit:'px'}});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				paddingTop:{value: value, unit:'px'},
                            				paddingBottom:{value: value, unit:'px'},
                            				paddingRight:{value: value, unit:'px'}
                            			});
                            		}
                            	}}})],1),_vm._m(0),_c('td',[_c('drag-input',{attrs:{"value":_vm.styleJSON.paddingRight.value,"icon":"arrows-h"},on:{"input":function (value){
                            		_vm.setStyle({paddingRight:{value: value, unit:'px'}});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({paddingLeft:{value: value, unit:'px'}});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				paddingLeft:{value: value, unit:'px'},
                            				paddingBottom:{value: value, unit:'px'},
                            				paddingTop:{value: value, unit:'px'}
                            			});
                            		}
                            	}}})],1)]),_c('tr',[_c('td'),_c('td',[_c('drag-input',{attrs:{"value":_vm.styleJSON.paddingBottom.value,"icon":"arrows-v"},on:{"input":function (value){
                            		_vm.setStyle({paddingBottom:{value: value, unit:'px'}});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({paddingTop:{value: value, unit:'px'}});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				paddingLeft:{value: value, unit:'px'},
                            				paddingRight:{value: value, unit:'px'},
                            				paddingTop:{value: value, unit:'px'}
                            			});
                            		}

                            	}}})],1),_c('td')])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticStyle:{"border":"1px dashed grey","padding":"16px 26px","display":"inline-block"}})])}]

export { render, staticRenderFns }